export default __webpack_public_path__ + "media/1234567890.72d85bc0.png";